<template>
    <div v-if="state" class="AlgoliaEventsDateFilter">
        <BaseIcon
            icon="date-picker-icon"
            class="AlgoliaEventsDateFilter__icon-calendar text--blue"
        />
        <DatePicker
            placeholder="Dates"
            :init-options="{
                dateFormat: 'U',
                maxDate: state.range.max.toString(),
                minDate: state.range.min.toString(),
                mode: 'range',
                ...defaultDate
            }"
            @change="refineDate"
            @mounted="handleMounted"
        />
        <BaseIcon
            icon="chevron-down-icon"
            class="AlgoliaEventsDateFilter__icon-chevron text--blue"
        />
    </div>
</template>
<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectRange } from 'instantsearch.js/es/connectors'
import moment from 'moment';

export default {
    data: () => ({
        datepicker: null
    }),
    props: {
        attribute: {
            type: String,
            required: true
        }
    },
    mixins: [
        createWidgetMixin({ connector: connectRange })
    ],
    watch: {
        'state.start': function () {
            const empty = this.state.start[0] == -Infinity && this.state.start[1] == Infinity;
            if (empty && this.datepicker) {
                this.datepicker.clear();
            }
        },
        'state.range': function () {
            if (this.datepicker) {
                this.datepicker.set('maxDate', this.state.range.max.toString());
                this.datepicker.set('minDate', this.state.range.min.toString());
            }
        }
    },
    computed: {
        widgetParams() {
            return {
                attribute: this.attribute,
            };
        },
        defaultDate() {
            const urlParams = new URLSearchParams(window.location.search);
            const startDate = urlParams.get('startDate');
            const endDate = urlParams.get('endDate');
            if (startDate && endDate) {
                const startDateParse = moment(startDate, 'D-MMM-YY').format('X');
                const endDateParse = moment(endDate, 'D-MMM-YY').format('X');
                return {
                    defaultDate: [startDateParse, endDateParse]
                }
            }
            return {}
        }
    },
    methods: {
        refineDate(datesTimestamps) {
            if (datesTimestamps.length > 1) {
                this.state.refine([
                    datesTimestamps[0],
                    datesTimestamps[1]
                ])
            }
        },
        handleMounted(instance) {
            this.datepicker = instance;
        }
    }
}
</script>
<style lang="scss">
    .AlgoliaEventsDateFilter {
        position: relative;
        border-bottom: 2px solid getColour("blue");
        padding: 9px;
        padding-left: 40px;
        padding-right: 0;

        @include media-query(desk) {
            margin-left: 1em;
        }

        input {
            border: none;
            color: getColour('grey', 'dark');
            font-family: $base-font-family;
            font-size: 19px;

            @include media-query(desk-wide) {
                font-size: 22px;
            }

            @include media-query(tiny) {
                font-size: 16px;
            }
        }

        ::-webkit-input-placeholder {
          color: getColour('grey', 'dark');
        }
    }

    .AlgoliaEventsDateFilter__icon-calendar {
        position: absolute;
        left: 0;
        font-size: 24px;
    }

    .AlgoliaEventsDateFilter__icon-chevron {
        position: absolute;
        right: 0;
        font-size: 16px;
        top: 17px;
        z-index: -1;

        @include media-query(tiny) {
            top: 15px;
        }
    }

    .AlgoliaEventsDateFilter__date {
        background-color: transparent;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    ::-webkit-input-placeholder {
        color: getColour('grey', 'dark');
    }

    .flatpickr-monthDropdown-months {
        -webkit-appearance: none !important;
        padding-right: 12px !important;
    }

    .numInputWrapper {
        position: relative;

        &:before, &:after  {
            content: '';
            position: absolute;
            border-bottom-color: rgba(0, 0, 0, 0.9);
            border-left-width: 4px;
            border-right-width: 4px;
            border-bottom-width: 7px;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: 4px solid #000;
            left: -10px;
            top: 5px;
            transform: scaleY(1.6);
        }

        &:after {
            top: 15px;
            transform: scaleY(1.6) rotate(180deg);
        }
    }



</style>

